var _style, _g, _path, _g2, _linearGradient, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{opacity:.99}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.2,
    y1: 3.005,
    x2: 36.2,
    y2: 101,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#00807f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#009393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#00b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#08b8b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14bbbb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.2 1l26.9 26.7V99H.3V1h44.9z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2 1l26.9 26.7V99H.3V1h44.9z",
    fillOpacity: 0,
    stroke: "#006e6c",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 91.1V71.2h6.5c2.5 0 4.1.1 4.8.3 1.1.3 2.1.9 2.9 1.9.8 1 1.2 2.3 1.2 3.9 0 1.2-.2 2.2-.7 3.1-.4.8-1 1.5-1.7 2s-1.4.8-2.1.9c-1 .2-2.4.3-4.2.3H12v7.5H8zm4-16.5v5.6h2.2c1.6 0 2.7-.1 3.2-.3.5-.2 1-.5 1.3-1 .3-.4.5-1 .5-1.5 0-.7-.2-1.3-.6-1.8-.4-.5-1-.8-1.6-.9-.5-.1-1.4-.1-2.9-.1H12zm14.6 16.5V71.2h3.9l8.2 13.2V71.2h3.7V91h-4l-8.1-12.9V91h-3.7zm29.5-7.3v-3.3h8.7v7.9c-.8.8-2.1 1.5-3.7 2.1-1.6.6-3.2.9-4.9.9-2.1 0-3.9-.4-5.5-1.3S48 88 47.2 86.4c-.8-1.6-1.2-3.4-1.2-5.3 0-2.1.4-3.9 1.3-5.5s2.1-2.8 3.8-3.7c1.3-.7 2.9-1 4.8-1 2.5 0 4.4.5 5.8 1.5s2.3 2.5 2.7 4.3l-4 .7c-.3-1-.8-1.7-1.6-2.3-.8-.6-1.7-.8-2.9-.8-1.8 0-3.2.6-4.2 1.7s-1.6 2.8-1.6 4.9c0 2.4.5 4.1 1.6 5.3s2.4 1.8 4.1 1.8c.8 0 1.7-.2 2.5-.5s1.6-.7 2.2-1.2v-2.5h-4.4z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.214,
    y1: 74.229,
    x2: 58.667,
    y2: 87.682,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6ede8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#d3ebe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c7e3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#b7d8d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#a0cbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#84bab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#62a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#349394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#007f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#006b6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006b69"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.2 1l26.9 26.7H45.2V1z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2 1l26.9 26.7H45.2V1z",
    fillOpacity: 0,
    stroke: "#006e6c",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.25,
    y1: 37.353,
    x2: 36.25,
    y2: 85.161,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#008281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#006a69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003836"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7 56.8c-1.6-.8-4.6-6.6-9.2-7-4-.3-9.1-1.8-11.9-2-3.5-5.8-9.5-15-14.5-19.9l13.8.7C37.2 19.8 27.7 23 27.7 23l6.4-5.3c-8.2-3.3-11.6 4.7-11.6 4.7-8.5-4.7-12.9 3.3-12.9 3.3l8.8.6C8.4 29.1 11.2 39 11.2 39l8.9-8c-1.9 4.4 2.3 7.5 2.3 7.5L25 27.7s9.3 10.6 12.2 21.4c-3.7 1.9-9.5 5-14 5.6-6.2.8-13.5 5-13.5 5v4.9h53.1l-.1-7.8z",
    opacity: 0.99,
    fill: "url(#SVGID_3_)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.1dce96db7470b4d462d22742c24b0e2d.svg";
export { ForwardRef as ReactComponent };